/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralType } from './ReferralType';
import {
    ReferralTypeFromJSON,
    ReferralTypeFromJSONTyped,
    ReferralTypeToJSON,
    ReferralTypeToJSONTyped,
} from './ReferralType';

/**
 * 
 * @export
 * @interface Referral
 */
export interface Referral {
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    sender_facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    sender_organization_id: string;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    target_discharge_date: Date;
    /**
     * 
     * @type {ReferralType}
     * @memberof Referral
     */
    referral_type: ReferralType;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    status: ReferralStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    close_reason: ReferralCloseReasonEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    sent_at: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    confirmed_at: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    closed_at: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    created_by_user_id: string;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    updated_at: Date;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    updated_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    first_name: string | null;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    last_name: string | null;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    ssn: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    dob: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    latest_activity_at?: Date | null;
}


/**
 * @export
 */
export const ReferralStatusEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Confirmed: 'confirmed',
    Closed: 'closed'
} as const;
export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];

/**
 * @export
 */
export const ReferralCloseReasonEnum = {
    ConfirmedElsewhere: 'confirmed_elsewhere',
    Declined: 'declined',
    Lost: 'lost',
    Withdrawn: 'withdrawn'
} as const;
export type ReferralCloseReasonEnum = typeof ReferralCloseReasonEnum[keyof typeof ReferralCloseReasonEnum];


/**
 * Check if a given object implements the Referral interface.
 */
export function instanceOfReferral(value: object): value is Referral {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('sender_organization_id' in value) || value['sender_organization_id'] === undefined) return false;
    if (!('target_discharge_date' in value) || value['target_discharge_date'] === undefined) return false;
    if (!('referral_type' in value) || value['referral_type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('close_reason' in value) || value['close_reason'] === undefined) return false;
    if (!('sent_at' in value) || value['sent_at'] === undefined) return false;
    if (!('confirmed_at' in value) || value['confirmed_at'] === undefined) return false;
    if (!('closed_at' in value) || value['closed_at'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    if (!('updated_by_user_id' in value) || value['updated_by_user_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('ssn' in value) || value['ssn'] === undefined) return false;
    if (!('dob' in value) || value['dob'] === undefined) return false;
    return true;
}

export function ReferralFromJSON(json: any): Referral {
    return ReferralFromJSONTyped(json, false);
}

export function ReferralFromJSONTyped(json: any, ignoreDiscriminator: boolean): Referral {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'lead_id': json['lead_id'],
        'sender_facility_id': json['sender_facility_id'],
        'sender_organization_id': json['sender_organization_id'],
        'target_discharge_date': (new Date(json['target_discharge_date'])),
        'referral_type': ReferralTypeFromJSON(json['referral_type']),
        'status': json['status'],
        'close_reason': json['close_reason'],
        'sent_at': (json['sent_at'] == null ? null : new Date(json['sent_at'])),
        'confirmed_at': (json['confirmed_at'] == null ? null : new Date(json['confirmed_at'])),
        'closed_at': (json['closed_at'] == null ? null : new Date(json['closed_at'])),
        'created_at': (new Date(json['created_at'])),
        'created_by_user_id': json['created_by_user_id'],
        'updated_at': (new Date(json['updated_at'])),
        'updated_by_user_id': json['updated_by_user_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'ssn': json['ssn'],
        'dob': (json['dob'] == null ? null : new Date(json['dob'])),
        'latest_activity_at': json['latest_activity_at'] == null ? undefined : (new Date(json['latest_activity_at'])),
    };
}

export function ReferralToJSON(json: any): Referral {
    return ReferralToJSONTyped(json, false);
}

export function ReferralToJSONTyped(value?: Referral | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'lead_id': value['lead_id'],
        'sender_facility_id': value['sender_facility_id'],
        'sender_organization_id': value['sender_organization_id'],
        'target_discharge_date': ((value['target_discharge_date']).toISOString().substring(0,10)),
        'referral_type': ReferralTypeToJSON(value['referral_type']),
        'status': value['status'],
        'close_reason': value['close_reason'],
        'sent_at': (value['sent_at'] == null ? null : (value['sent_at'] as any).toISOString()),
        'confirmed_at': (value['confirmed_at'] == null ? null : (value['confirmed_at'] as any).toISOString()),
        'closed_at': (value['closed_at'] == null ? null : (value['closed_at'] as any).toISOString()),
        'created_at': ((value['created_at']).toISOString()),
        'created_by_user_id': value['created_by_user_id'],
        'updated_at': ((value['updated_at']).toISOString()),
        'updated_by_user_id': value['updated_by_user_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'ssn': value['ssn'],
        'dob': (value['dob'] == null ? null : (value['dob'] as any).toISOString().substring(0,10)),
        'latest_activity_at': value['latest_activity_at'] == null ? undefined : ((value['latest_activity_at'] as any).toISOString()),
    };
}

